import React from 'react';
import { Box } from '@mui/material';

// Icône "Contratos" : emoji ✍️ (main qui écrit), utilisée comme icône du contrat
// dans CompetitionsViewer, Seguimiento et BigBoard. Exposée comme composant
// acceptant sx/className, pour rester interchangeable avec une icône MUI
// (prop `icon` des Chip, Typography, etc.).
const ContractIcon = (props) => (
  <Box component="span" role="img" aria-label="contrato" {...props}>
    ✍️
  </Box>
);

export default ContractIcon;
